//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useForm } from 'react-hook-form'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../modularModule.scss'
import CourseFilterTermSelect from 'app_components/modules/CourseFilterTermSelect/CourseFilterTermSelect'
import { Terms } from 'app_types/admin/term/term.types'
import InputFileComponent from 'app_components/commons/InputFileComponent/InputFileComponent'

// @ADD Component types
interface IModularModuleLayoutProps {
  onHandleSubmit: (data: any) => void
  editData?: any
  customErrors?: any
  viewer: boolean
}

const ModularModuleLayout: React.FC<IModularModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const formHook = useForm()

  return(
    <div className='modular_form-component'>
      <fieldset disabled={props.viewer ? true : false}>
        <form onSubmit={formHook.handleSubmit(props.onHandleSubmit)}>
          <div className="d-flex align-items-center mb-2">
            <h3 className="form-title">{t("modules.modular.general_information")}</h3>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='name'>{t('labels.modular.name')}</label>
                {formHook.errors.name && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <input
                  name='name'
                  className={`form-control ${formHook.errors.name && 'is-invalid'}`}
                  type='text'
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.name) ? props?.editData?.name : ''}
                />
              </div>
            </div>

            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='description'>{t('labels.modular.description')}</label>
                {formHook.errors.description && <div className='invalid-feedback'>{t('errors.this_field_is_required')}</div>}
                <textarea
                  name='description'
                  className={`form-control ${formHook.errors.description && 'is-invalid'}`}
                  ref={formHook.register({ required: true })}
                  defaultValue={(props?.editData?.description) ? props?.editData?.description : ''}
                />
              </div>
            </div>
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor='filterCategories'>Categorías de filtro</label>
                <CourseFilterTermSelect
                  defaultValue={props?.editData?.filterCategories}
                  name='filterCategories'
                  formHook={formHook}
                  allowedTypes={[Terms.COURSE_SECTOR, Terms.COURSE_TOPIC]}
                />
              </div>
            </div>
            <div className="col-md-12">
              <InputFileComponent
                as='image'
                formHook={formHook}
                label='Imagen'
                name='coverFile'
                defaultUrl={props?.editData?.coverUrl}
                extensions={['svg']}
              />
            </div>
          </div>

          {!props.viewer && (
            <div className='buttons-group'>
              <div className='text-right'>
                <button className='btn btn-primary' type='submit'>
                  {t('buttons.save')}
                </button>
              </div>
            </div>
          )}
        </form>
      </fieldset>
    </div>
  )
}

export default ModularModuleLayout
